import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { isApiError } from './errors.ts';
import { queryKeys } from './queryKeys.ts';

const MAX_RETRIES = 2;
const STALE_TIME_MS = 30_000;

const shouldRetry = (failureCount: number, error: unknown): boolean =>
  failureCount < MAX_RETRIES && (!isApiError(error) || error.transient);

export const createQueryClient = (): QueryClient => {
  // A lost session anywhere means the cached session view is stale; guards react to the refetch.
  const onError = (error: unknown) => {
    if (isApiError(error) && error.code === 'unauthenticated') {
      void queryClient.invalidateQueries({ queryKey: queryKeys.session() });
    }
  };
  const queryClient: QueryClient = new QueryClient({
    queryCache: new QueryCache({ onError }),
    mutationCache: new MutationCache({ onError }),
    defaultOptions: {
      queries: { retry: shouldRetry, staleTime: STALE_TIME_MS, refetchOnWindowFocus: true },
      mutations: { retry: false },
    },
  });
  return queryClient;
};
